import "./about.css";
import { ArrowDownward } from "@material-ui/icons";
import { Link } from "react-router-dom";
import {useEffect, useState } from 'react';
import { HTTP } from "../../api/http-common";
import { HTMLDescription } from '../projects/HTMLDescription';


function About() {
  const [data, setData] = useState(null);
  const [backEndSkills, setBackEndSkills] = useState([]);
  const [frontEndSkills, setFrontEndSkills] = useState([]);
  const [dataScienceSkills, setDataScienceSkills] = useState([]);

  useEffect(() => {
    
    let url = '/api/portfolio/about-us/'
      HTTP.get(url)
      .then(function (response) {
          if(response.status === 200)
          {
            let data = response.data.results
            if (data.length > 0)
            {
              setData(data[0])              
            }
            
          }
      })
      .catch(function (err) {
          console.log(err);
      });

      // this is call for technology_url
      let technology_url = '/api/portfolio/technology/'
      HTTP.get(technology_url)
      .then(function (response) {
          if(response.status === 200)
          {
            let data = response.data.results
            if (data.length > 0 )
            {
              // Filter based on type
              setBackEndSkills(data.filter(item => item.type === 'back_end'));
              setFrontEndSkills(data.filter(item => item.type === 'front_end'));
              setDataScienceSkills(data.filter(item => item.type === 'ds'));         
            }
            
          }
      })
      .catch(function (err) {
          console.log(err);
      });
  
    }, []); 
  

  return (
    <div style={{ marginTop: "60px" }}>
      <p className="text-center contText">About Me</p>
      <br />
      <div className="row topRow">
        <div className="col text-col">
          
        <div className="image-col">
          <img
            src={ data ? data.image :"assets/images/Mohd Nafees Image2.png"}
            className="myImage"
            alt="..."
          />
        </div>

          <p className="pText text-left">
            {/* <span className="hello text-center">{ data ? data.title : "Hello friends!" }</span>
            <br /> */}
            <br />

            { data ? 
              <HTMLDescription description={data.description} />
              : 
              <>
              "Hi, I'm Mohd Nafees, a passionate and dedicated software professional from Ahmedabad, 
              Gujarat, India (380023). I hold an Integrated Master of Computer Applications (I-MCA) 
              degree from Indus University, Ahmedabad. With a strong foundation in software development 
              and a deep interest in building impactful digital solutions, I strive to continuously grow 
              and contribute to the tech community."
              
              With solid experience in backend, frontend, and data science, I bring a comprehensive 
            approach to full-stack application development and intelligent data-driven solutions.
              </>
            }
            {/* Full Stack of a software Developer Front end development, Back end development, Database, Server, API, and version controlling systems. */}
          </p>
          <p className="pText">

          <span className="techLaguageTitle">🎨 Frontend Development</span><br/>
            I craft interactive, responsive, and accessible user interfaces using:{" "}
            <span className="techLaguage">

              {
                frontEndSkills.length > 0 ?
                frontEndSkills.map(skill => (
                    skill.name + " | " 
                ))
                :
                "HTML, CSS, Bootstrap, JavaScript, Jquery, and React JS."
              }

            </span>
            <br/><br/>
            
          <span className="techLaguageTitle">🔧 Backend Development</span><br/>
            I have professional experience in designing and developing robust backend systems using:{" "}

            <span className="techLaguage">
            {
                backEndSkills.length > 0 ?
                backEndSkills.map(skill => (
                  skill.name + " | " 
                ))
                :
                "Python, Django, Django Rest Framework, Flask, Fastapi"
              }
              
            </span>
            <br /><br/>

            <span className="techLaguageTitle">📊 Data Science</span><br/>
            With practical experience in data science and AI, I specialize in building predictive models, 
            performing data analysis, and creating intelligent solutions using machine learning,
             deep learning, NLP, chatbot development, and Generative AI.:{" "}
            <span className="techLaguage">
            {
                dataScienceSkills.length > 0 ?
                dataScienceSkills.map(skill => (
                    skill.name + " | " 
                ))
                :
                "Pandas, NumPy, Matplotlib, Seaborn, Scikit-learn, Tensorflow, Keras, NLP, GenAI."
              }
            
            </span>

          </p>
        </div>
      </div>

      <div className="container text-center">
        <p className="text-center contText">Our Achievements</p>
        <br />
        <p className="contp mb-4">
          Here my Skills and works. <ArrowDownward />
        </p>

        <div className="row skillsRow ">
          <div className="col skillsCol">
            <Link to="/resume">
              <p className="titleText">Experience</p>
              <p className="titleValue">{ data ? data.experience : "3 + Years" }</p>
            </Link>
          </div>
          <div className="col skillsCol">
            <Link to="/skill">
              <p className="titleText">Skills</p>
              <p className="titleValue">{ data ? data.skill_count + " +" : "12 +" }</p>
            </Link>
          </div>
          <div className="col skillsCol">
            <Link to="/certificate">
              <p className="titleText">Certificates</p>
              <p className="titleValue">{ data ? data.certificate_count + " +" : "6 +" }</p>
            </Link>
          </div>
          <div className="col skillsCol">
            <Link to="/project">
              <p className="titleText">Projects</p>
              <p className="titleValue">{ data ? data.project_count + " +" : "17 +" }</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
